export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "vertical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verticale"])},
        "no_business_vertical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun produit d'assurance"])}
      },
      "en": {
        "vertical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vertical"])},
        "no_business_vertical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No insurance product"])}
      }
    }
  })
}
